class BlockStoriesDark {
	constructor() {
		new Swiper(".stories-swiper-left", {
			effect: 'fade',
			fadeEffect: {
				crossFade: true
			},
			allowTouchMove: false,
			navigation: {
				nextEl: '.block-stories-dark .swiper-next',
				prevEl: '.block-stories-dark .swiper-prev',
			},
			pagination: {
				el: '.block-stories-dark .dots',
				type: 'bullets',
				clickable: true
			},
		});
		new Swiper(".stories-swiper-right", {
			effect: 'fade',
			fadeEffect: {
				crossFade: true
			},
			allowTouchMove: false,
			navigation: {
				nextEl: '.block-stories-dark .swiper-next',
				prevEl: '.block-stories-dark .swiper-prev',
			},
			pagination: {
				el: '.block-stories-dark .dots',
				type: 'bullets',
				clickable: true
			},
		});
	}
}
